import React from 'react'

import { Wrapper } from './GridItem.styles'

const GridItem = ({
    width,
    height,
    boxShadow,
    left,
    margin,
    children,
    whiteSpace,
    gridArea,
    gridCol,
    gridRow,
    display,
    gridTempRows,
    gridTempCols,
    gridTemplate,
    gridAutoRows,
    gridAutoCols,
    gridAutoFlow,
    gridRowGap,
    gridColGap,
    alignText,
    flexWrap,
    justifyContent,
    flexDirection,
    justifyItems,
    justifySelf,
    alignSelf,
    alignItems,
    alignContent,
    fontSize,
    overflow,
    color,
    background,
    onClick,
    cursor,
    padding,
    fontWeight,
    borderBottom }) => {
    const isObject = (variable) => {
        return typeof (variable) === 'object' && !Array.isArray(variable) && variable !== null
    }
    return (
        <Wrapper
            background={background}
            boxShadow={boxShadow}
            cursor={cursor}
            display={display}
            onClick={typeof (onClick) === 'function' ? onClick : undefined}
            margin={margin}
            padding={padding}
            overflow={overflow}
            height={height}
            left={left}
            width={width}
            flexDirection={flexDirection}
            flexWrap={flexWrap}
            justifySelf={justifySelf}
            alignSelf={alignSelf}
            gridTempRows={isObject(gridTemplate) ? gridTemplate.rows : gridTempRows}
            gridTempCols={isObject(gridTemplate) ? gridTemplate.cols : gridTempCols}
            gridAutoRows={gridAutoRows}
            gridAutoCols={gridAutoCols}
            gridAutoFlow={gridAutoFlow}
            gridColGap={gridColGap}
            gridRowGap={gridRowGap}
            whiteSpace={whiteSpace}
            gridArea={gridArea}
            gridCol={gridCol}
            gridRow={gridRow}
            alignText={alignText}
            justifyContent={justifyContent}
            justifyItems={justifyItems}
            alignContent={alignContent}
            alignItems={alignItems}
            color={color}
            fontSize={fontSize}
            fontWeight={fontWeight}
            borderBottom={borderBottom}
        >{children}</Wrapper>
    )
}

export default GridItem